<div class=" scrollbar app">
    <div class="pad15 border mb15">
        <ng-template #content let-modal>
            <div class="modal-header">
                <h4 class="modal-title" id="modal-basic-title" translate>lblParkingImage</h4>
                <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
            </div>
            <ng-container *ngIf="url !== undefined; else load_else">
                <div class="modal-body">
                    <img af-image [data-code]="url" class="img-fluid" alt="">
                </div>
            </ng-container>
            <ng-template #load_else>
                <p translate style="text-align: center;" class="mt5 ml5 mb5">lblNoRecordsFound</p>
            </ng-template>
        </ng-template>
        <ng-container *ngIf="isParkingImageAvailable; else do_else">
            <button class="btn btn-sm btn-outline-primary" (click)="openModal()" aria-label="Center Align" translate>lblSeeTheParkingImage</button>
            <span class="ml5">{{response?.comments}}</span>
        </ng-container>
        <ng-template #do_else>
            <p translate>lblParkingImageIsNotUploadedFromDWOApp</p>
        </ng-template>
        <hr>
        <pre>{{closeResult}}</pre>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
        <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate>
            <em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
    </div>
</div>